"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LightBulbOn = createSVGIcon(
  <>
    <path
      d="M7.997 16h4.848l2.073-4.81c.054-.125.082-.26.082-.397v-.214a4.58 4.58 0 1 0-9.158 0v.214c0 .137.028.272.082.397z"
      stroke="currentColor"
    />
    <path
      d="M8 18h5M9 20h3M10 3V1M3 8 1 7M18 8l2-1"
      strokeLinecap="round"
      stroke="currentColor"
    />
  </>,
  "LightBulb",
  {
    viewBox: "0 0 21 21",
    titleAccess: "LightBulb",
    fill: "none",
  }
);
